import React from "react";
import Gallery360 from "@components/Gallery360";
import getConfig from "next/config";
const {
  publicRuntimeConfig: { settings },
} = getConfig();

const Image360 = ({ picked }) => {
  if (picked && picked.length > 0) {
    return (
      <Gallery360>
        {picked.map((image) => (
          <img
            key={image.name}
            src={`${settings.cdn}${image.path}${image.name}`}
          />
        ))}
      </Gallery360>
    );
  }

  return null;
};

export default Image360;
